$(document).ready(function () {
  $(".sizing-slider-xs-first").slick({
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
  });
  $(".sizing-slider-xs-second").slick({
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
  });

  $(".favorite-xs-slider").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
  });
});
jQuery(".size-btn").click(function () {
  jQuery(".size-btn").removeClass("active");
  jQuery(this).addClass("active");

  let myID = jQuery(this).attr("id");

  jQuery(".commanClass1").removeClass("showdata");
  jQuery(".hidedata-" + myID).addClass("showdata");
});
